module.exports = __webpack_public_path__ + "media/images/menu_trucho-20e2c5222ce0ecd871d2742ebfd270dc.png";